var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGlobePurple = function SvgGlobePurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.775 14.248A9.748 9.748 0 0 0 3.537 2.708a9.745 9.745 0 0 0 6.67 17.04h.014a9.762 9.762 0 0 0 8.494-5.38l.002-.003a.751.751 0 0 0 .058-.117ZM18.25 10c0 .983-.175 1.958-.519 2.879l-4.35-2.676a1.49 1.49 0 0 0-.585-.208l-2.14-.289a1.51 1.51 0 0 0-1.436.639h-.8l-.357-.737a1.5 1.5 0 0 0-1.035-.813l-.616-.132.236-.56a.75.75 0 0 1 .691-.46h1.504c.253 0 .503-.064.725-.186l1.148-.634c.1-.056.195-.123.28-.2L13.52 4.34a1.491 1.491 0 0 0 .416-1.59A8.257 8.257 0 0 1 18.25 10Zm-16.5 0a8.2 8.2 0 0 1 .887-3.719l.977 2.609a1.493 1.493 0 0 0 1.09.94l.516.11.005.002 1.13.242a.751.751 0 0 1 .517.407l.197.408a1.5 1.5 0 0 0 1.35.846h.105l-.722 1.619a1.498 1.498 0 0 0 .269 1.629l1.504 1.627a.75.75 0 0 1 .186.652l-.168.868A8.26 8.26 0 0 1 1.75 10Z",
    fill: "#7160C5"
  })));
};

export default SvgGlobePurple;